<!-- Add User Data Information during the creation -->

<template>
    <div class="modal-mask" v-if="$store.getters.USERPROFILE['user-invitation']||$store.getters.USERPROFILE['user-administration']">
        <section class="modal reduced" v-if="step == 1">
            <div class="content">
                <h1>{{$t('addUser.title')}}</h1>
            </div>
            <hr>
            <form @submit.prevent="">
                <div class="content">
                    <p>
                        {{$t('addUser.selectData')}}<br>
                        {{$t('addUser.receiveAnEmailToFinish')}}
                    </p>
                    <br>
                    <div class="column">
                        <label>{{$t('addUser.email')}}</label>
                        <input type="email" v-model="user['email']" />
                    </div>
                        <p class="accentuate">{{$t('addUser.firstname')}}</p>
                        <input type="text" v-model="user['first-name']"/>
                        <p class="accentuate">{{$t('addUser.name')}}</p>
                        <input type="text" v-model="user['name']"/>
                        <p class="accentuate">{{$t('addUser.enterprise')}}</p>
                        <input type="text" v-model="user['company']"/>
                        <p class="accentuate">{{$t('addUser.phoneNumber')}}</p>
                        <input type="text" v-model="user['phone-number']"/>
                    
            </div>
            </form>
            <hr>
            <div class="content">
                <div class="row">
                    <button @click="step = 2"  >{{$t('button.next')}}</button>
                    <a  @click="$emit('close')">{{$t('button.cancel')}}</a>
                </div>
            </div>
       
        </section>
        <UserRight 
            v-if="step == 2" :user="user"
            @previous="step = 1" @close="$emit('close')" @get="$emit('get')">
        </UserRight>
    </div>
</template>

<script>
    //import Users from '@/services/Users.js' 
    import UserRight from '@/components/users/add/UserRight'
    export default {
        components: { UserRight },
        data () {
            return {
                user: {
                    "email": "",
                    "first-name": "",
                    "name": "",
                    "company": "",
                    "phone-number": "",
                    "user-profile-id": "",
                    "archived":"false",
                    "password":"1234", //TODO a retirer
                    "creator-id": "1" //TODO a retirer

                },
                step: 1,
            }
        }
    }
</script>